import { AfterViewInit, Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TypeMerchantUserEnum } from 'app/models';
import { AppDataService, MerchantUserService } from 'app/services';
import { Utils } from 'app/utils';
import { MessageService } from 'primeng/api';
import { CreateMerchantSingleEmployeeComponent } from './create-merchant-single-employee/create-merchant-single-employee.component';
import { MerchantEmployeeDetailsComponent } from './merchant-employee-details/merchant-employee-details.component';
import { MerchantEmployeesSelectionComponent } from './merchant-employees-selection/merchant-employees-selection.component';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'merchant-employees',
    templateUrl: './merchant-employees.component.html',
    styleUrls: ['./merchant-employees.component.scss',
    '../../../../../styles/m3-defaul-material-theme.scss'],
    providers: [MessageService]
})
export class MerchantEmployeesComponent implements OnInit, AfterViewInit {
    private liveAnnouncer = inject(LiveAnnouncer);
    @Input()
    public merchantId: any;

    @Input()
    public storeId: any;

    @Input()
    public reviewEmployee: boolean = false;

    public roleId: number = 0;
    public merchantUserId: number = 0;
    public showMerchantEmployeeDetailSideBar: boolean = false;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        private messageService: MessageService, public appData: AppDataService,
        private merchantUserService: MerchantUserService,
        private dialog: MatDialog) {
        this.handleCreatePopupHide = this.handleCreatePopupHide.bind(this);
        this.roleId = parseInt(appData.authData.roleId, 10);
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
    }

    ngOnInit(): void {
        this.getMerchantEmployees(0);
    }

    //Create component
    public showCreateEmployee: boolean = false;
    public isCreateEmployee: boolean = true;

    public menuTab = TypeMerchantUserEnum;
    public activeTab: TypeMerchantUserEnum = this.menuTab.StoreEmployees;
    public typeCreatedEmployee: TypeMerchantUserEnum = this.menuTab.StoreEmployees;

    public merchantUsers: Array<any> = [];
    public selectedUsers: any;
    public selectedUser: any = {};
    public showEditFields: boolean = false;
    public cols: any[] = [
        { field: 'UserId', header: 'Employee ID', width: '20%' },
        { field: 'CreatedAt', header: 'Created', width: '20%' },
        { field: 'UserName', header: 'Name', width: '20%' },
        { field: 'RoleName', header: 'Role', width: '20%' },
        { field: 'StoreName', header: 'Location', width: '20%' }
    ];

    // Grid settings
    public rowsPerPage: number = 5;
    public rowsPerPageOptions: Array<number> = [5, 10, 20];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string = '';
    public sortDirection: 'asc' | 'desc' | '' = '';
    private sortOrder: number = 1;

    private searchTimer: number = 0;

    public loading: boolean = false;
    displayedColumns: string[] = ['UserId', 'CreatedAt', 'UserName', 'RoleName', 'Location', 'action'];
    public filter: {
            UserId?: number | string;
            searchName: string;
            searchTerm?: string;
      } = { UserId: '', searchName: '', searchTerm: '' };
    dataSource = new MatTableDataSource();

    public handlePopupLinkClick(user: any, showEditFields: boolean): void {
        if(showEditFields){
            const dialogRef = this.dialog.open(CreateMerchantSingleEmployeeComponent, {
                width: '60%',
                disableClose: true,
                data: {
                    type: this.typeCreatedEmployee,
                    merchantId: this.merchantId,
                    storeId: this.storeId,
                    employee: this.selectedUser,
                    isEditable: true,
                    user
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been updated' });
                  this.getMerchantEmployees(0);
                }
            });
        } else {
            const dialogRef = this.dialog.open(MerchantEmployeeDetailsComponent, {
                width: '30%',
                disableClose: true,
                data: {
                    type: this.typeCreatedEmployee,
                    merchantId: this.merchantId,
                    storeId: this.storeId,
                    employee: this.selectedUser,
                    isEditable: true,
                    user
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                  this.getMerchantEmployees(0);
                }
            });
        }
    }

    onNextPage(event: any){
        console.log(event);
        this.rowsPerPage = event.pageSize;
        this.getMerchantEmployees(event.pageIndex * event.pageSize);
    }

    onSortChange(event: any){
        this.sortField = event.active;
        this.sortOrder = event.direction === 'asc' ? 1 : -1;
        this.getMerchantEmployees(event.pageIndex);
    }

    public getMerchantEmployees(skip: number, take: number = this.rowsPerPage,
                      sortField: string = this.sortField, sortDirection: 'asc' | 'desc' | '' = this.sortDirection) {
        this.loading = true;
        const dto = {
            MerchantId: this.merchantId,
            StoreId: this.storeId,
            GetAdmins: this.activeTab === this.menuTab.WebAdmins,
            Skip: skip,
            SearchName: this.filter.searchName,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: sortDirection === 'asc' ? 1 : -1
        };

        this.merchantUserService.getMerchantUsers(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.merchantUsers = data.Items.map((x: any) => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt) + ' ' + Utils.utcToLocaleTimeString(x.CreatedAt);
                    x.BirthdayStr = Utils.utcToLocaleDateString(x.Birthday);
                    x.Birthday = new Date(x.Birthday);
                    return x;
                });
                this.dataSource = new MatTableDataSource(this.merchantUsers);
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public deleteMerchantUser(merchantUserId: number) {
        const dto = {
            MerchantUserId: merchantUserId,
            MerchantId: this.merchantId
        };

        this.merchantUserService.deleteMerchantUserById(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully deleted' });
                this.getMerchantEmployees(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleChangeTabMenu(event: any) {
        this.activeTab = event.index + 1;
        this.getMerchantEmployees(0);
        this.typeCreatedEmployee = event.index + 1;
    }

    public handleShowCreateEmployee(tab: TypeMerchantUserEnum) {
        this.typeCreatedEmployee = tab;
        this.dialog.open(MerchantEmployeesSelectionComponent, {width: '70%', data: {
            type: this.typeCreatedEmployee,
            merchantId: this.merchantId,
            storeId: this.storeId,
            employee: this.selectedUser,
            merchantEmployeesComponent: this
        }});
    }

    public handleCreatePopupHide() {
        this.showCreateEmployee = false;
        this.getMerchantEmployees(0);
    }

    public openMerchantEmployeeDetailSideBar(merchantUserId: number) {
        this.merchantUserId = merchantUserId;
        this.showMerchantEmployeeDetailSideBar = !this.showMerchantEmployeeDetailSideBar;
    }
    changedShowMerchantEmployeeDetailSideBarEmit(value: any) {
        this.showMerchantEmployeeDetailSideBar = value;
    }

    applyFilter() {
        if (this.searchTimer) {
              window.clearTimeout(this.searchTimer);
        }

        // Parse the search term
        const term = (this.filter.searchTerm || '').trim();
        if (term === '') {
            this.filter.UserId = '';
            this.filter.searchName = '';
        } else if (/^\d+$/.test(term)) {
            this.filter.UserId = term;
            this.filter.searchName = '';
        } else {
            this.filter.UserId = '';
            this.filter.searchName = term;
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchantEmployees(0, this.rowsPerPage, this.sortField, this.sortDirection);
            this.searchTimer = 0;
        }, 500);
    }

    announceSortChange(sortState: Sort) {
        // details about the values being sorted.
        if (sortState.direction) {
          this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
        } else {
          this.liveAnnouncer.announce('Sorting cleared');
        }
      }
}
